// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1lYea","delete":"styles_delete__24ZXw","update":"styles_update__2bqIn","add":"styles_add__LsOi-"};